(function () {
    'use strict';

    angular
        .module('staticHtmlPageControllers')
        .controller('StaticHtmlPageController', Controller);

    Controller.$inject = ['$scope', 'topBarService', 'page'];

    function Controller($scope, topBarService, page) {
        $scope.page = page;

        topBarService.setModule(undefined);
        topBarService.setTitleAndIcon(page.Title, page.TitleIconName);
    }
})();